<template>
  <DropdownMenuItem
    class="group h-10 flex flex-col justify-center self-stretch py-px px-1.5 outline-none select-none transition-colors data-[disabled]:pointer-events-none"
  >
    <div
      :class="
        cn(
          'relative flex items-center grow py-[9px] px-2.5 gap-2 bg-primary rounded-sm cursor-default hover:cursor-pointer ',
          {
            'text-secondary group-hover:text-secondary_hover group-focus:text-secondary_hover group-data-[disabled]:text-disabled group-hover:bg-primary_hover group-focus:bg-primary_hover':
              type === 'gray',
            'text-error-primary group-data-[disabled]:text-utility-error-500 group-hover:bg-error-primary group-focus:bg-error-primary':
              type === 'destructive',
          },
          props.class
        )
      "
    >
      <slot name="start" />
      <span class="capitalize text-style-sm font-medium">
        {{ label }}
      </span>
      <slot name="end" />
    </div>
  </DropdownMenuItem>
</template>

<script setup>
import { DropdownMenuItem } from "radix-vue";
import { cn } from "@/Utils/cn";

const props = defineProps({
  label: { type: String, required: true },
  type: { type: String, required: false },
  class: { type: null, required: false },
});
</script>
